import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { ERROR500, GRAY400, PRIMARY600, SUCCESS500, WARNING400, WHITE } from '../../common/colorConstants';
import { Icon } from '../../Icon';
import { jsx as _jsx } from "react/jsx-runtime";
export function IndicatorBadgeIcon(props) {
  var _extends2;
  var iconId = props.Icon,
    _props$intent = props.intent,
    intent = _props$intent === void 0 ? 'primary' : _props$intent,
    _props$size = props.size,
    size = _props$size === void 0 ? 'xs' : _props$size,
    sx = props.sx;
  var theme = useTheme();
  return /*#__PURE__*/_jsx(Box, {
    sx: _extends((_extends2 = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_extends2, ".MuiSvgIcon-root", {
      height: iconSize[size].size,
      width: iconSize[size].size
    }), "alignItems", 'center'), "backgroundColor", intentBgColors[intent].backgroundColor), "borderColor", WHITE), "borderRadius", size === '2xl' ? '13.333px' : '12px'), "borderStyle", 'solid'), "borderWidth", size === '2xl' ? '1.667px' : '1.5px'), "display", 'flex'), "height", iconSize[size].size), "justifyContent", 'center'), _defineProperty(_extends2, "width", iconSize[size].size)), sx),
    "data-element": "Box",
    "data-component": "IndicatorBadgeIcon",
    "data-source-file": "IndicatorBadgeIcon.tsx",
    children: iconId && /*#__PURE__*/_jsx(Icon, {
      color: theme.palette.common.white,
      iconId: iconId,
      size: Number(iconSize[size].size)
    })
  });
}
export var iconSize = {
  '2xl': {
    size: 20
  },
  lg: {
    size: 16
  },
  md: {
    size: 14
  },
  sm: {
    size: 12
  },
  xl: {
    size: 18
  },
  xs: {
    size: 10
  }
};
export var intentBgColors = {
  error: {
    backgroundColor: ERROR500
  },
  neutral: {
    backgroundColor: GRAY400
  },
  primary: {
    backgroundColor: PRIMARY600
  },
  success: {
    backgroundColor: SUCCESS500
  },
  warning: {
    backgroundColor: WARNING400
  }
};